import { render } from "./ProductFormTabBatches.vue?vue&type=template&id=2db32ac5"
import script from "./ProductFormTabBatches.vue?vue&type=script&lang=js"
export * from "./ProductFormTabBatches.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__